export const message = {
  createDocumentFormSuccess: 'Document successfully saved.',
  deleteDocumentFormSuccess: 'Document successfully deleted.',
  deleteDocumentFormError: 'Failed to delete document. Document might use to other document.',
  savingWithNoChangesMessage: 'You must update at least 1 document field to be able to save a draft?',
  formError: 'Form cannot be submitted. Please fill-up mandatory fields and/or fix errors found below then re-submit the form.',
  noAccessMessage: 'You are not allowed to access the form. Page will now redirect to previous screen.'
};